<template v-slot:top>
    <div>
        <v-row> 
            <v-sheet
            elevation="10"
            class="pa-12"
            style="margin-top:10%;"
            >
                <v-form ref="form" v-model="valid" >
                    <div class="my-2">
                        <h3>Konu Başlığını Yazınız</h3>
                        <v-textarea
                            clearable
                            label="Konu Başlığı"
                            row-height="20"
                            :maxlength="100"
                            v-model="title"
                            :auto-grow="true"
                            :filled="true"
                            :outlined="true"
                            :rules= "[v => !!v || 'Konu Başlığı Gerekli']"
                            required
                        ></v-textarea>
                        <h3>Mesajınızın İçeriğini Yazınız</h3>
                        <v-textarea
                            clearable
                            label="İçerik"
                            :maxlength="350"
                            v-model="text"
                            :auto-grow="true"
                            :filled="true"
                            :outlined="true"
                            :rules= "[v => !!v || 'Mesaj İçeriği Gerekli']"
                            required
                        ></v-textarea>
                        <v-btn :disabled="!valid" color="grey" @click="addMessage">EKLE</v-btn>
                    </div>
                </v-form>
            </v-sheet>
        </v-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            text : "",
            title : "",
            valid : true
        }

    },
    methods: {
        
        async addMessage(){

            /*await axios.post('http://localhost:3000/information', {
              adminText: this.text,
              adminTitle: this.title
            })
            .then(function (res) {
              if (res.data.isValid==1) {
                console.log(res.data.notification)
                alert(res.data.value)
              }
              else if(res.data.isValid==0){
                console.log(res.data.notification);
                alert("Mesaj Gönderilirken Bir Hata Oluştu.")
              }
            })
            .catch(function (error) {
              console.log(error);
              alert("Mesaj Gönderilirken Bir Hata Oluştu.")
            });*/
            this.text = "",
            this.title = ""
        }
    }
}
</script>